module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAADiCAMAAACBfOzMAAAANlBMVEUAAADS0NDS0NDS0NDS0NDT0NDS0NDS0NDS0NDS0NDS0NDS0NDS0NDS0NDS0NDT0NDS0NDS0NApgQuvAAAAEXRSTlMAytRK8Aj5fY3y3ZiFs1U7FrTPIsAAAADdSURBVFjD7dXLCoMwGERhq01ivdb3f9kGuhjKwHHbxbj9Dr8JUTKM14DPIx6Px+PxeDwe//H3je8H+1In9PF6TuzXa2LvE8gtMLfAXIG7AnAF5grAFZhDIFcArsBcAboCOQRyD+QeoOuDkVsArsDc1iD3CeY2Ab1PKOjX80Cv64ne8P21FfSV998G8joX9I3PrxXyOncAb4W8bp3BNVxuw921b/KG/29thVz7dtfS3LU08tlRruHuvjT3VsC/RwI+4/3Th5M/1s7g55/fz/F4PB6Px+PxuJ7xxvcF+QNuG0DugcsQwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/jiantou.png
// module id = 9dzv
// module chunks = 1